module.exports = __webpack_public_path__ + "static/image-03-a@2x-588332452ef8431b24e42875ac51291b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-03-a@2x.jpg
// module id = 428
// module chunks = 3627797113349 20562973939449 33019919093843